var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dictionary-simple-table',{attrs:{"dictionary_link":"/product-altum-styles","title":"Lista styli Altum","numeral_text":['styl', 'style', 'styli'],"columns_title":['name']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }